import { isBrandMetas, isCategoryMetas, isCombinationMetas, isTagMetas } from './type-guards'

import { PLPBasicMetasProps, PLPPages } from '../types'

export function getPLPSEODescription(page: PLPPages, basicMetas: PLPBasicMetasProps) {
    switch (page) {
        case PLPPages.BrandCategoriesCombination:
        case PLPPages.Facets:
            return isCombinationMetas(page, basicMetas) ? basicMetas.seo?.footerDescription : undefined

        case PLPPages.Tags:
            return isTagMetas(page, basicMetas) ? basicMetas.seo?.footerDescription : undefined

        case PLPPages.Brands:
            return isBrandMetas(page, basicMetas) ? basicMetas.description : undefined

        case PLPPages.Categories:
            return isCategoryMetas(page, basicMetas) ? basicMetas?.description : undefined

        case PLPPages.Search:
            return undefined

        default:
            return undefined
    }
}
